import { auditLogsClient, connectBaseApi, createRpcQuery } from "@racoon/api";

export const auditLogsGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listAuditLogs: createRpcQuery(build, auditLogsClient, "listAuditLogs", {
      providesTags: ["AuditLog"],
    }),
  }),
});

export const { useListAuditLogsQuery } = auditLogsGrpc;
